import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface ExplanationFormProps {
  explanation: string;
  onExplanationChange: (value: string) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export const ExplanationForm = ({
  explanation,
  onExplanationChange,
  onSubmit,
  isSubmitting,
}: ExplanationFormProps) => {
  return (
    <div className="space-y-2">
      <Label>Explication de la différence</Label>
      <Textarea
        value={explanation}
        onChange={(e) => onExplanationChange(e.target.value)}
        placeholder="Expliquez la raison de cette différence..."
        className="min-h-[100px]"
      />
      <Button
        onClick={onSubmit}
        disabled={!explanation.trim() || isSubmitting}
        className="w-full"
        variant={!explanation.trim() || isSubmitting ? "secondary" : "default"}
      >
        {isSubmitting ? "Enregistrement..." : "Enregistrer l'explication"}
      </Button>
    </div>
  );
};